module.exports = __webpack_public_path__ + "img/Rectangle40.05d49164.svg";